/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */

import React from 'react';
import {Color, IconProps, IconSize} from '../types/types';
import {ThemeIconProvider} from './ThemeIconProvider';
import useIconDLS from './useIconDLS';

/*
 * Defines the Design Language System (DLS) Asset Equipment Icon component.
 */
export const AssetEquipmentIcon = (props: IconProps) => {
  const {stroke = undefined} = props;
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <ThemeIconProvider name='AssetEquipmentIcon' {...props} legacyIcon={(
      <svg width={iconSize} height={iconSize} viewBox='0 0 40 40' fill='none'>
        <path d='M33.224 31.471h-18.98a1.783 1.783 0 01-1.256-.515 1.755 1.755 0 01-.519-1.247 1.753 1.753 0 01.978-1.584l2.882-1.435c.244-.126.516-.191.792-.19h13.445c.292 0 .579.073.835.211l2.658 1.404A1.747 1.747 0 0135 29.672v.026a1.747 1.747 0 01-.515 1.255 1.772 1.772 0 01-1.26.518zM7.818 22.703a2.786 2.786 0 002.796-2.776 2.786 2.786 0 00-2.796-2.776 2.786 2.786 0 00-2.797 2.776 2.786 2.786 0 002.797 2.776zM29.668 23.932v-10.86a.72.72 0 00-.214-.511.731.731 0 00-.515-.212h-5.454a1.215 1.215 0 00-.883.38l-4.668 6.095a.489.489 0 00-.133.338v5.54a.489.489 0 00.495.492h10.122a1.255 1.255 0 001.16-.78c.062-.154.092-.317.09-.482z'
          fill={iconColor}
          stroke={stroke} />
        <path d='M21.587 14.455l-1.5 3.694c-.074.185-.25.285-.383.222L5.138 11.447a.322.322 0 01-.101-.411L5.77 9.23a.322.322 0 01.362-.227l15.332 5.029a.311.311 0 01.123.422z'
          fill={iconColor}
          stroke={stroke} />
        <path d='M8.604 11.405H7.031v6.675h1.573v-6.675z'
          fill={iconColor} />
      </svg>
    )} />
  );
};
